import { Attribute } from "./attribute";
import { LogisticClass, LogisticPrice } from "./logistic";
import { PickingDelay } from "./shop";
import { TrackingInfo } from "./tracking";
import { CartPicture } from "@/models/picture";
import { Product } from "@/models/product";
import { Price } from "./price";
import { Address } from "@/models/address";
import {ShoppingCartItem, UnitPrice} from "@/models/shopping";

export class Shipment {
  id?: string | null;
  trackingInfo?: TrackingInfo | null;
  items?: ShipmentItem[];
  shipmentWeight?: number;
  shipmentMethod?: ShipmentMethods | null;
  address?: Address | null;
  price?: Price;

  public static of(data: any): Shipment {
    const s: Shipment = new Shipment();

    s.id = data.id;
    s.items = []
    data?.items.forEach(ci => s.items?.push(ShipmentItem.of(ci)));
    s.shipmentWeight = 0;
    s.price = Price.of(data.price);
    s.trackingInfo = data.trackingInfo;
    s.shipmentMethod = data.shipmentMethod ? ShipmentMethods.of(data.shipmentMethod) : null;
    s.address = data.address;
    return s;
  }
}

export class ShipmentShop {
  id?: string;
  name?: string;
  returnPolicy?: string;
  logo?: string;

  public static of(data: any): ShipmentShop {
    const s: ShipmentShop = new ShipmentShop();

    s.id = data.id;
    s.name = data.name;
    s.returnPolicy = data.returnPolicy;
    s.logo = data.logo;

    return s;
  }
}

export class ShipmentMethods {
  id?: string;
  carrier?: string;
  deliveryTime?: string;
  deliveryTimeUnit?: string;
  name?: string;
  price?: Price;

  public static of(data: any): ShipmentMethods {
    const s: ShipmentMethods = new ShipmentMethods();
    s.id = data.id;
    s.carrier = data.carrier;
    s.name = data.name;
    s.deliveryTime = data.deliveryTime;
    s.deliveryTimeUnit = data.deliveryTimeUnit;
    s.price = Price.of(data.price);

    return s;
  }
}

export class ShipmentOffer {
  id?: string;
  shop?: ShipmentShop;
  pickingDelay?: PickingDelay;
  stockQuantity?: number;
  logisticClass?: LogisticClass;
  regularPrice?: Price;
  discountPrice?: Price;
  minimalOrderQuantity?: number;
  maximalOrderQuantity?: number;

  public static of(data: any): ShipmentOffer {
    const s: ShipmentOffer = new ShipmentOffer();
    s.id = data.id;
    s.shop = data.shop;
    s.pickingDelay = data.pickingDelay;
    s.stockQuantity = data.stockQuantity;
    s.logisticClass = data.logisticClass;
    s.regularPrice = Price.of(data.regularPrice);
    s.discountPrice = Price.of(data.discountPrice);
    s.minimalOrderQuantity = data.minimalOrderQuantity;
    s.maximalOrderQuantity = data.maximalOrderQuantity;

    return s;
  }
}

export class ShipmentProduct {
  slug?: string;
  reference?: string;
  name?: string;
  cover?: CartPicture;
  configurableAttributes?: any;
  attributeValuesByAttributeName?: Record<string, Attribute>;
  selectedAttributes?: any;
  offer?: ShipmentOffer;

  public static of(data: any): ShipmentProduct {
    const s: ShipmentProduct = new ShipmentProduct();

    s.slug = data.slug;
    s.reference = data.reference;
    s.name = data.name;
    s.configurableAttributes = data?.configurableAttributes;
    s.attributeValuesByAttributeName = data.attributeValuesByAttributeName;
    s.offer = ShipmentOffer.of(data.offer);

    if (data?.pictures?.length > 0) {
      const cover = data.pictures.find(p => p.isCover === true);

      if (cover) {
        s.cover = CartPicture.of(cover, data.name);
      } else {
        s.cover = CartPicture.of(null, data.name);
      }
    } else {
      s.cover = CartPicture.of(null, data.name);
    }

    if (data?.configurableAttributes) {
      const selectedAttributes = {};
      for (let attr = 0; attr < data?.configurableAttributes.length; attr++) {
        const label = data?.configurableAttributes[attr];

        if (data?.attributeValuesByAttributeName[label]) {
          selectedAttributes[label] = data?.attributeValuesByAttributeName[label];
        }
      }
      s.selectedAttributes = selectedAttributes;
    }
    return s;
  }
}

export class ShipmentItem {
  quantity?: number;
  product?: ShipmentProduct;
  price?: Price;
  unitPrice?: UnitPrice;

  public static of(data: any): ShipmentItem {
    const s: ShipmentItem = new ShipmentItem();

    s.quantity = data.quantity;
    s.product = ShipmentProduct.of(data.product);
    s.price = Price.of(data.price);
    s.unitPrice = UnitPrice.of(data.product?.offer);
    return s;
  }
}

export class ShipmentsItem {
  price?: Price;
  product?: Product;
  quantity?: number;

  public static of(data: any): ShipmentsItem {
    const s: ShipmentsItem = new ShipmentsItem();
    s.price = Price.of(data.price);
    s.product = data.product;
    s.quantity = data.quantity;

    return s;
  }
}

export class ShipmentOptions {
  shipment?: Shipment[];
  options?: LogisticPrice[];

  public static of(data: any): ShipmentOptions {
    const s: ShipmentOptions = new ShipmentOptions();

    s.shipment = data.shipment;
    s.options = data.options;

    return s;
  }
}